import { Col, Form, Row } from 'react-bootstrap'
import { emptyDate, isEmptyDate } from '../../../utils/emptyDate'
import React, { useCallback, useEffect, useState } from 'react'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { getIsoDate } from '../../../utils/getIsoDate'
import { useTranslation } from 'react-i18next'
import { StyledValidationMessage } from '../../Employees/Form/formHelper'
import MandatoryField from '../../MandatoryField/MandatoryField'


const StatisticOverTimePeriod = ({ formData, setFormData, formErrors }) => {
    const { t } = useTranslation()
    const [dateFrom, setDateFrom] = useState(null)
    const [dateTo, setDateTo] = useState(null)
    const [groupByTarget, setGroupByTarget] = useState(false)
    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                return { ...prev, startDate: getIsoDate(dateFrom, false) }
            }
            delete prev.startDate
            return prev
        })
    }, [setFormData, dateFrom])
    useEffect(() => {
        setFormData(prev => {
            if (dateFrom) {
                let isoDate = getIsoDate(dateTo, true)
                return { ...prev, endDate: isEmptyDate(isoDate) ? emptyDate : isoDate }
            }
            delete prev.endDate
            return prev
        })
    }, [setFormData, dateTo, dateFrom])
    const handleChangeDate = useCallback(setDate => date => {
        setDate(date)
    }, [])
    const updateCheckboxAndRadioProperty = (event, name) => {
        switch (name) {
            case 'byOffice':
                setGroupByTarget(false)
                setFormData(prev => ({
                    ...prev,
                    groupBy: name 
                    }))
                break
            case 'byTarget':
                setGroupByTarget(true)
                setFormData(prev => ({
                    ...prev,
                    groupBy: name 
                    }))
                break
            default:
        }
    }

    return (
        <div>
            <>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>{`${t('from')}${'*'}`}</Form.Label>
                            <CustomDatePicker
                                dateFormat="dd.MM.yyyy"
                                placeholderText={t('date')}
                                onChange={handleChangeDate(setDateFrom)}
                                showYearDropdown
                                selected={dateFrom}
                                isInvalid={formErrors && formErrors.startDate}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>{`${t('to')}${'*'}`}</Form.Label>
                            <CustomDatePicker
                                dateFormat="dd.MM.yyyy"
                                placeholderText={t('date')}
                                onChange={handleChangeDate(setDateTo)}
                                showYearDropdown
                                selected={dateTo}
                                isInvalid={formErrors && formErrors.endDate}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                {formErrors && formErrors.startDate && <StyledValidationMessage>{formErrors.startDate}</StyledValidationMessage>}
                {formErrors && formErrors.endDate && <StyledValidationMessage>{formErrors.endDate}</StyledValidationMessage>}
            </>
            <Form.Group className="mb-3">
                <Form.Label className="d-block">{t('reportConfig:groupBy')}</Form.Label>
                <Form.Check
                    inline
                    type="radio"
                    id="groupByOffice"
                    name="groupBy"
                    label={t('reportConfig:groupByOffice')}
                    checked={!groupByTarget}
                    onChange={(e) => updateCheckboxAndRadioProperty(e, 'byOffice')}
                />
                <Form.Check
                    inline
                    type="radio"
                    id="groupByTarget"
                    name="groupBy"
                    label={t('reportConfig:groupByTarget')}
                    checked={groupByTarget}
                    onChange={(e) => updateCheckboxAndRadioProperty(e, 'byTarget')}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>{t(`reportConfig:emailAddress`)}</Form.Label>
                <Form.Control
                    name="emailAddress"
                    onChange={e => setFormData(prev => ({
                        ...prev,
                        emailAddress: e.target.value
                    }))}
                    value={formData.emailAddress || ''}
                    isInvalid={formErrors && formErrors.emailAddress}
                    autoComplete="email" />
                <Form.Control.Feedback type="invalid">
                    {formErrors && formErrors.emailAddress}
                </Form.Control.Feedback>
            </Form.Group>
            <MandatoryField />
        </div>
    )
}
export default StatisticOverTimePeriod